import styled from 'styled-components';

export const StyledBannerCard = styled.div<{
  backgroundImage?: string | null;
  hasCustomBackground?: boolean;
}>`
  width: 100%;
  height: 180px;
  border-radius: 8px;
  background-color: ${({ hasCustomBackground }) =>
    hasCustomBackground ? 'transparent' : '#04533f'};
  background-image: ${({ backgroundImage, hasCustomBackground }) =>
    hasCustomBackground && backgroundImage
      ? `url(${backgroundImage})`
      : 'none'};
  background-size: cover;
  background-position: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #b2d8cc;
`;

export const StyledBannerContent = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  position: relative;
  z-index: 1;

  .banner-summary {
    color: white;
    font-size: 18px;
    font-weight: 600;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    flex: 1;
    display: flex;
    align-items: center;
  }
`;

export const StyledNewUpdateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #ffe785;
  font-size: 12px;
  font-weight: 500;

  svg {
    flex-shrink: 0;
  }
`;

export const StyledCheckNowButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: #008060;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    background: #f6f6f6;
  }
`;
